import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebTransaction } from "../../../models";

@Component({
    selector: "app-notes-dialog.component",
    templateUrl: "./notes-dialog.component.html",
    styleUrls: ["./notes-dialog.component.scss"],
})
export class NotesDialogComponent 
{
    note: WebTransaction;

    constructor(
        public dialogRef: MatDialogRef<NotesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data)
    {
        this.note = data.transaction;
    }
}